import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { Store } from '@ngxs/store';
import { takeUntil, auditTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EngineProgressState } from '../../state/progress/engine.progress.state';


@Component({
  selector: 'app-engine-progress',
  templateUrl: './engine-progress.component.html',
  styleUrls: ['./engine-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EngineProgressComponent implements OnInit, OnDestroy {

  private ngUnsubscribe = new Subject();

  constructor(
    private store: Store,
    private changeDetecton: ChangeDetectorRef
  ) {}

  storyLoadProgress = 0;

  ngOnInit() {
    this.store.select(EngineProgressState.getStoryLoadProgress)
      .pipe(
        takeUntil(this.ngUnsubscribe),
        auditTime(50)
      )
      .subscribe((progress) => {
        this.storyLoadProgress = progress;
        this.changeDetecton.markForCheck();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
